import React, { useMemo } from "react";
import { FixedSizeList as List } from "react-window";

// CSS styles for the list item
const listItemStyle = {
  fontSize: "10px",
  display: "flex",
};

const MenuList = ({ options, children, maxHeight, getValue }) => {
  const [value] = getValue();

  // Memoize the height and initialOffset calculation
  const height = useMemo(() => 30, []); // Height of each option
  const initialOffset = useMemo(
    () => options.indexOf(value) * height,
    [options, value]
  );

  // Memoize the renderItem function using useMemo
  const renderItem = useMemo(() => {
    return ({ index, style }) => (
      <div style={{ ...style, ...listItemStyle }}>
        {children[index]} {/* Render each item */}
      </div>
    );
  }, [children]);

  // Ensure options and children are not empty
  if (!children || children.length === 0 || !options || options.length === 0) {
    return null; // Or render a fallback UI if needed
  }

  return (
    <List
      height={maxHeight}
      itemCount={children.length}
      itemSize={height}
      initialScrollOffset={initialOffset}
    >
      {renderItem}
    </List>
  );
};

export default React.memo(MenuList);
